import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { IconButton, InputAdornment } from '@mui/material'
import { ClearOutlined } from '@mui/icons-material'
import moment from 'moment'

export const DateRangePicker = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        label="Début de période"
        value={startDate}
        onChange={(newValue) => setStartDate(newValue)}
        sx={{ marginX: '5px', backgroundColor: 'white' }}
        maxDate={endDate}
        slotProps={{
          textField: {
            clearable: true,
            InputProps: {
              startAdornment: (
                <InputAdornment>
                  {startDate && (
                    <IconButton onClick={() => setStartDate(null)}>
                      <ClearOutlined />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            },
          },
        }}
      />
      <div> - </div>
      <DatePicker
        label="Fin de période"
        value={endDate}
        onChange={(newValue) => setEndDate(newValue)}
        maxDate={moment().utc()}
        sx={{ marginX: '5px', backgroundColor: 'white' }}
      />
    </LocalizationProvider>
  )
}
